export const urlToTitle = (url: string) => decodeURIComponent(url).split(`/`).pop()?.replace(/.pdf/g, ``).trim()
